// Code generated by protoc-gen-ts. DO NOT EDIT.
// protoc-gen-ts is an Art Processors production, found in mos-sdk-py.

import { Page } from "generated/mos/pagination";
import { Placement } from "generated/mos/placement";
import { Codec, DecodeContext, RemoteObject, Timestamp, WebRPCError, decodeMessageRepeated, ensureScalar, ensureScalarOptional } from "generated/webrpc";

export namespace GetTMSObjectRequest {
  export const refName = "mos.org.getty.integration_tms.GetTMSObjectRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly tmsObjectRef: { readonly typename: 'mos.org.getty.integration_tms.TMSObject', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    tmsObjectRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.integration_tms.GetTMSObjectRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["tmsObjectRef"] = v["tmsObjectRef"];
      return out as any as Entity;
    }
  }();
}

export namespace GetTMSObjectResponse {
  export const refName = "mos.org.getty.integration_tms.GetTMSObjectResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly tmsObject: TMSObject.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    tmsObject: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["tmsObject"] = TMSObject.codec.encode(v.tmsObject);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.integration_tms.GetTMSObjectResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["tmsObject"] = ctx.decode(TMSObject.codec, v["tmsObject"], "tmsObject");
      return out as any as Entity;
    }
  }();
}

export namespace ListTMSObjectsRequest {
  export const refName = "mos.org.getty.integration_tms.ListTMSObjectsRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    // If page size is <= 0, ERR_PAGINATION_SIZE_REQUIRED is raised.
    readonly page: Page.Entity | undefined,
    // Passing an invalid SortOrder will cause an INVALID_ARGUMENT error to be raised.
    readonly sortOrder: ListTMSObjectsRequest.SortOrder,
    readonly filter: ListTMSObjectsRequest.ByRef.Entity | string | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    page: undefined,
    sortOrder: "SORT_DEFAULT",
    filter: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["page"] = Page.codec.encode(v.page);
      obj["sortOrder"] = v.sortOrder;
      {
        const uv: any = v.filter;
        if (uv !== undefined) {
          if (uv.type == "mos.org.getty.integration_tms.ListTMSObjectsRequest.ByRef") {
            obj["byRef"] = ListTMSObjectsRequest.ByRef.codec.encode(uv);
          }
          else if (typeof(uv) === "string") {
            obj["searchTerm"] = uv;
          }
          else {
            throw new WebRPCError("union discrimination failed for .mos.org.getty.integration_tms.ListTMSObjectsRequest.filter");
          }
        }
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.integration_tms.ListTMSObjectsRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["page"] = ctx.decode(Page.codec, v["page"], "page");
      {
        const ev = ensureScalar(ctx, v["sortOrder"], "string") || defaults["sortOrder"];
        if (!ListTMSObjectsRequest.SortOrderValues.has(ev as any)) {
          throw ctx.error(`unknown value "${ev}" for enum .mos.org.getty.integration_tms.ListTMSObjectsRequest.SortOrder`);
        }
        out["sortOrder"] = ev as any;
      }
      {
        if (v["byRef"] !== undefined) {
          out["filter"] = ctx.decode(ListTMSObjectsRequest.ByRef.codec, v["byRef"], "byRef");
        }
        if (v["searchTerm"] !== undefined) {
          out["filter"] = ensureScalar(ctx, v["searchTerm"], "string");
        }
      }
      return out as any as Entity;
    }
  }();
  export namespace ByRef {
    export const refName = "mos.org.getty.integration_tms.ListTMSObjectsRequest.ByRef" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly tmsObjectRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.integration_tms.TMSObject', readonly id: string }>,
    }
    export const defaults: Entity = {
      type: refName,
      tmsObjectRefs: [],
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.integration_tms.ListTMSObjectsRequest.ByRef");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["tmsObjectRefs"] = v["tmsObjectRefs"];
        return out as any as Entity;
      }
    }();
  }

  export const SortOrderValues = new Set([
    'SORT_DEFAULT' as const,
    'SORT_MODIFIED_DESC' as const,
  ]);
  export type SortOrder = typeof SortOrderValues extends Set<infer U> ? U : never;

}

export namespace ListTMSObjectsResponse {
  export const refName = "mos.org.getty.integration_tms.ListTMSObjectsResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly tmsObjects: ReadonlyArray<TMSObject.Entity>,
    readonly nextPage: Page.Entity | undefined,
    // Estimated number of available results, after search queries and filtering but before pagination.
    // This may change during pagination, and should not be relied upon for list termination.
    readonly totalItems: number,
  }
  export const defaults: Entity = {
    type: refName,
    tmsObjects: [],
    nextPage: undefined,
    totalItems: 0,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["tmsObjects"] = [];
      for (const item of v.tmsObjects) {
        obj["tmsObjects"].push(TMSObject.codec.encode(item));
      }
      obj["nextPage"] = Page.codec.encode(v.nextPage);
      obj["totalItems"] = v.totalItems;
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.integration_tms.ListTMSObjectsResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["tmsObjects"] = decodeMessageRepeated(ctx, TMSObject.codec, v["tmsObjects"], "tmsObjects");
      out["nextPage"] = ctx.decode(Page.codec, v["nextPage"], "nextPage");
      out["totalItems"] = ensureScalar(ctx, v["totalItems"], "number");
      return out as any as Entity;
    }
  }();
}

// XXX: This is a WIP; details are collated in this Paper document:
// https://paper.dropbox.com/doc/Getty-TMS-Activity-Stream-API--AkCgNIxNL_5TOR76Lyd3PsYdAg-vVE2TtayNJc0tPb8hHBmV
export namespace TMSObject {
  export type Ref = { readonly typename: 'mos.org.getty.integration_tms.TMSObject', readonly id: string };
  export function isRef(v: { typename: string, id: string } | undefined): v is Ref {
    return !!v && typeof v.id === "string" && (v.typename === 'mos.org.getty.integration_tms.TMSObject');
  }
  export function mustRef(v: { typename: string, id: string } | undefined): Ref {
    if (!isRef(v)) throw new WebRPCError(`Ref ${v && v.typename}:${v && v.id} is not a valid ref for a TMSObject`);
    return v;
  }
  export const refName = "mos.org.getty.integration_tms.TMSObject" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.integration_tms.TMSObject', readonly id: string } | undefined,
    readonly tmsId: string,
    readonly accessionNumber: string,
    readonly dorId: string,
    readonly dorUuid: string,
    readonly primaryTitle: string,
    readonly iiifImageUrl: string,
    readonly imageMediaRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
    readonly placeCreated: string,
    readonly dateCreated: string,
    readonly materials: string,
    readonly creditLine: string,
    readonly objectCopyright: string,
    readonly imageCopyright: string,
    readonly objectDescription: string,
    readonly producedBy: string,
    readonly location: string,
    readonly spaceRef: { readonly typename: 'mos.structure.Space', readonly id: string } | undefined,
    readonly modifiedAt: Timestamp | undefined,
    // At 2020-03-17 This placement is generated from the `space_ref` so should only contain a SpacePlacement type.
    // This placement is used by the `Stop` for a LinkablePlacement, and the `Stop` is restricted to only having a `SpacePlacement` type.
    readonly placement: Placement.Entity | undefined,
    readonly alternateTitle1: string,
    readonly alternateTitle2: string,
    readonly alternateTitle3: string,
    readonly alternateTitle4: string,
    readonly alternateTitle5: string,
    readonly exhibitionTitle1: string,
    readonly exhibitionTitle2: string,
    readonly exhibitionTitle3: string,
    readonly exhibitionTitle4: string,
    readonly exhibitionTitle5: string,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
    tmsId: "",
    accessionNumber: "",
    dorId: "",
    dorUuid: "",
    primaryTitle: "",
    iiifImageUrl: "",
    imageMediaRef: undefined,
    placeCreated: "",
    dateCreated: "",
    materials: "",
    creditLine: "",
    objectCopyright: "",
    imageCopyright: "",
    objectDescription: "",
    producedBy: "",
    location: "",
    spaceRef: undefined,
    modifiedAt: undefined,
    placement: undefined,
    alternateTitle1: "",
    alternateTitle2: "",
    alternateTitle3: "",
    alternateTitle4: "",
    alternateTitle5: "",
    exhibitionTitle1: "",
    exhibitionTitle2: "",
    exhibitionTitle3: "",
    exhibitionTitle4: "",
    exhibitionTitle5: "",
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["ref"] = v.ref;
      obj["tmsId"] = v.tmsId;
      obj["accessionNumber"] = v.accessionNumber;
      obj["dorId"] = v.dorId;
      obj["dorUuid"] = v.dorUuid;
      obj["primaryTitle"] = v.primaryTitle;
      obj["iiifImageUrl"] = v.iiifImageUrl;
      obj["imageMediaRef"] = v.imageMediaRef;
      obj["placeCreated"] = v.placeCreated;
      obj["dateCreated"] = v.dateCreated;
      obj["materials"] = v.materials;
      obj["creditLine"] = v.creditLine;
      obj["objectCopyright"] = v.objectCopyright;
      obj["imageCopyright"] = v.imageCopyright;
      obj["objectDescription"] = v.objectDescription;
      obj["producedBy"] = v.producedBy;
      obj["location"] = v.location;
      obj["spaceRef"] = v.spaceRef;
      obj["modifiedAt"] = v.modifiedAt ? v.modifiedAt.value : "";
      obj["placement"] = Placement.codec.encode(v.placement);
      obj["alternateTitle1"] = v.alternateTitle1;
      obj["alternateTitle2"] = v.alternateTitle2;
      obj["alternateTitle3"] = v.alternateTitle3;
      obj["alternateTitle4"] = v.alternateTitle4;
      obj["alternateTitle5"] = v.alternateTitle5;
      obj["exhibitionTitle1"] = v.exhibitionTitle1;
      obj["exhibitionTitle2"] = v.exhibitionTitle2;
      obj["exhibitionTitle3"] = v.exhibitionTitle3;
      obj["exhibitionTitle4"] = v.exhibitionTitle4;
      obj["exhibitionTitle5"] = v.exhibitionTitle5;
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.integration_tms.TMSObject");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      out["tmsId"] = ensureScalar(ctx, v["tmsId"], "string");
      out["accessionNumber"] = ensureScalar(ctx, v["accessionNumber"], "string");
      out["dorId"] = ensureScalar(ctx, v["dorId"], "string");
      out["dorUuid"] = ensureScalar(ctx, v["dorUuid"], "string");
      out["primaryTitle"] = ensureScalar(ctx, v["primaryTitle"], "string");
      out["iiifImageUrl"] = ensureScalar(ctx, v["iiifImageUrl"], "string");
      out["imageMediaRef"] = v["imageMediaRef"];
      out["placeCreated"] = ensureScalar(ctx, v["placeCreated"], "string");
      out["dateCreated"] = ensureScalar(ctx, v["dateCreated"], "string");
      out["materials"] = ensureScalar(ctx, v["materials"], "string");
      out["creditLine"] = ensureScalar(ctx, v["creditLine"], "string");
      out["objectCopyright"] = ensureScalar(ctx, v["objectCopyright"], "string");
      out["imageCopyright"] = ensureScalar(ctx, v["imageCopyright"], "string");
      out["objectDescription"] = ensureScalar(ctx, v["objectDescription"], "string");
      out["producedBy"] = ensureScalar(ctx, v["producedBy"], "string");
      out["location"] = ensureScalar(ctx, v["location"], "string");
      out["spaceRef"] = v["spaceRef"];
      {
        const tsv = ensureScalarOptional(ctx, v["modifiedAt"], "string");
        out["modifiedAt"] = tsv ? {type: "google.protobuf.Timestamp", value: tsv} : undefined;
      }
      out["placement"] = ctx.decode(Placement.codec, v["placement"], "placement");
      out["alternateTitle1"] = ensureScalar(ctx, v["alternateTitle1"], "string");
      out["alternateTitle2"] = ensureScalar(ctx, v["alternateTitle2"], "string");
      out["alternateTitle3"] = ensureScalar(ctx, v["alternateTitle3"], "string");
      out["alternateTitle4"] = ensureScalar(ctx, v["alternateTitle4"], "string");
      out["alternateTitle5"] = ensureScalar(ctx, v["alternateTitle5"], "string");
      out["exhibitionTitle1"] = ensureScalar(ctx, v["exhibitionTitle1"], "string");
      out["exhibitionTitle2"] = ensureScalar(ctx, v["exhibitionTitle2"], "string");
      out["exhibitionTitle3"] = ensureScalar(ctx, v["exhibitionTitle3"], "string");
      out["exhibitionTitle4"] = ensureScalar(ctx, v["exhibitionTitle4"], "string");
      out["exhibitionTitle5"] = ensureScalar(ctx, v["exhibitionTitle5"], "string");
      return out as any as Entity;
    }
  }();
}

